import React from "react";

const ComponentProcurement = ({ ...props }) => {
    return (
      <div>
        <p>
          Coming soon
        </p>
      </div>
    );
  };
  
  export default ComponentProcurement;